import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=f00b6896&scoped=true"
import script from "./CaseEdit.vue?vue&type=script&lang=js"
export * from "./CaseEdit.vue?vue&type=script&lang=js"
import style0 from "./CaseEdit.vue?vue&type=style&index=0&id=f00b6896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b6896",
  null
  
)

export default component.exports